var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppLayout",
    { attrs: { page: "/subscriptions", pageTitle: "Subscriptions" } },
    [
      _c(
        "Link",
        { attrs: { href: `/store` } },
        [
          _c(
            "jet-button",
            { staticClass: "ml-4", class: ["gradient-orange white--text"] },
            [_vm._v("\n            " + _vm._s(`Products`) + "\n        ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }